import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ChatGptList(props) {
    const [formData, setName] = useState({
        Chint: "",
        UrNm: "",
        PID: "",
        CaseNm: "",
        CaseResp: "",
    });
    const [QuesList, setQuesList] = useState([]);
    const [QuesList2, setQuesList2] = useState([]);
    const [EType, setType] = React.useState("");

    const [disable, setDisable] = useState(true);
    const [todate, setTodatePic] = useState("");
    const [fromdate, setFromdatePic] = useState("");
    const [FrDate, setFrDate] = useState("");
    const [ToDate, setToDate] = useState("");
    const [todateformat, setTodateformat] = useState("");
    const [fromdateformat, setFromdateformat] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedPosts, setpaginatedPosts] = useState();
    const ManagerId = localStorage.getItem("ManegerId");
    const Role = localStorage.getItem("URole");
    let [loading, setLoading] = useState(true);

    const [Record, seRecord] = useState([]);

    const csvLink = useRef();
    let pageSize = 10;

    const navigate = useHistory();

    useEffect(() => {
        LoadGptList();
    }, [pageSize]);

    const LoadGptList = () => {
        setLoading(true);
        const datavalue = {
            ManegId: Role == "Admin" ? 1 : ManagerId,
        };

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/GetChatQuesListDesc`,
            data: datavalue,
            headers: { "Content-Type": "multipart/form-data" },
        };

        axios(authOptions)
            .then((res) => {
                seRecord(res.data.length);
                if (res.data.length > 10) {
                    setQuesList(res.data);

                    setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
                } else {
                    setQuesList2(res.data);
                }
            })
            .finally(() => setLoading(false));
    };
    const pageCount = QuesList ? Math.ceil(QuesList.length / pageSize) : 0;
    if (pageCount === 1) return null;
    const pages = _.range(1, pageCount + 1);

    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setCurrentPage(currentPage);
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedPost = _(QuesList).slice(startIndex).take(pageSize).value();
        setpaginatedPosts(paginatedPost);
    };

    const handlefromdate = (date) => {
        const getfromdatevalue = formatDate(date);

        setFromdatePic(date);

        const setfromformat = getfromdatevalue.split("-");
        const setfromyear = setfromformat[0];
        const setfrommonth = setfromformat[1];
        const setfromdate = setfromformat[2];
        const setfromformatdate =
            setfromyear + "" + setfrommonth + "" + setfromdate;
        setFrDate(getfromdatevalue);
        setFromdateformat(setfromformatdate);
        setDisable(false);
    };
    const handletodate = (date) => {

        const gettodatevalue = formatDate(date);

        console.log("selected date changed", gettodatevalue);
        setTodatePic(date);
        const setdateformat = gettodatevalue.split("-");
        const settoyear = setdateformat[0];
        const settomonth = setdateformat[1];
        const settodate = setdateformat[2];
        const settodateformat = settoyear + "" + settomonth + "" + settodate;
        setToDate(gettodatevalue);
        setTodateformat(settodateformat);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        let formDataSet = new FormData();

        if (fromdateformat > todateformat) {
            alert("Please select valid date");
        } else {
            if (
                EType != "" ||
                FrDate != "" ||
                ToDate != "" ||
                formData.Chint != "" ||
                formData.UrNm != "" ||
                formData.PID != "" ||
                formData.CaseNm != "" ||
                formData.CaseResp != ""
            ) {
                formDataSet.append(
                    "fdate",
                    FrDate == null || FrDate == "" ? "" : FrDate
                );
                formDataSet.append(
                    "tdate",
                    ToDate == null || ToDate == "" ? "" : ToDate
                );
                formDataSet.append(
                    "Chint",
                    formData.Chint == null || formData.Chint == "" ? "" : formData.Chint
                );
                formDataSet.append(
                    "UsrNm",
                    formData.UrNm == null || formData.UrNm == "" ? "" : formData.UrNm
                );
                formDataSet.append(
                    "CaseNm",
                    formData.CaseNm == null || formData.CaseNm == ""
                        ? ""
                        : formData.CaseNm
                );
                formDataSet.append(
                    "CaseResp",
                    formData.CaseResp == null || formData.CaseResp == ""
                        ? ""
                        : formData.CaseResp
                );
                formDataSet.append(
                    "PID",
                    formData.PID == null || formData.PID == "" ? "" : formData.PID
                );
                formDataSet.append("CSrc", EType == null || EType == "" ? "" : EType);
                formDataSet.append("ManegId", Role == "Admin" ? 1 : ManagerId);

                const config = {
                    headers: { "content-type": "multipart/form-data" },
                };

                var authOptions = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}/GetFilterChatQues`,
                    data: formDataSet,
                    headers: { "Content-Type": "multipart/form-data" },
                };

                axios(authOptions)
                    .then((res) => {
                        seRecord(res.data.length);
                        if (res.data.length > 10) {
                            setQuesList(res.data);
                            setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
                        } else {
                            setQuesList2(res.data);
                        }
                    })

                    .catch((error) => {
                    })
                    .finally(() => setLoading(false));
            } else {
                LoadGptList();
            }
        }
    };

    const headers = [
        "Case Id",
        "User Name",
        "Case Name",
        "Question",
        "Response",
        "Expression",
        "Timestamp",
    ];
    const csvData =
        Record > 10
            ? [
                headers,
                ...QuesList.map((item) => {
                    let response, emotion;
                    try {
                        // Escape control characters before parsing JSON
                        const escapedJsonString = item.responces.replace(/[\x00-\x1F\x7F-\x9F]/g, function (c) {
                            return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
                        });

                        // Parse the JSON string
                        const parsedResponses = JSON.parse(escapedJsonString);

                        // Extract response and emotion
                        response = parsedResponses.response;
                        emotion = parsedResponses.emotion;
                    } catch (error) {
                        // Handle parsing errors
                        console.error("Error parsing JSON:", error);
                        response = null; // or some default value
                        emotion = null; // or some default value
                    }
                    return [
                        item.p_Id,
                        item.userName,
                        item.caseName,
                        item.question,
                        response,
                        emotion,
                        item.timestamp,
                    ];
                }),
            ]
            : [
                headers,
                ...QuesList2.map((item) => {
                    let response, emotion;
                    try {
                        // Escape control characters before parsing JSON
                        const escapedJsonString = item.responces.replace(/[\x00-\x1F\x7F-\x9F]/g, function (c) {
                            return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
                        });

                        // Parse the JSON string
                        const parsedResponses = JSON.parse(escapedJsonString);

                        // Extract response and emotion
                        response = parsedResponses.response;
                        emotion = parsedResponses.emotion;
                    } catch (error) {
                        // Handle parsing errors
                        console.error("Error parsing JSON:", error);
                        response = null; // or some default value
                        emotion = null; // or some default value
                    }
                    return [
                        item.p_Id,
                        item.userName,
                        item.caseName,
                        item.question,
                        response,
                        emotion,
                        item.timestamp,
                    ];
                }),
            ];

    const LoadCsv = () => {
        //console.log("click condition")
    };

    const downloadCsv = (csvData, filename) => {
        const data = encodeURI(
            `data:text/csv;charset=utf-8,${csvData
                .map((row) => row.join(","))
                .join("\n")}`
        );
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", filename);
        link.click();
    };

    const handleChangeType = (event) => {
        setType(event.target.value);
        if (event.target.value != "") {
        } else {
            window.location.reload(true);
        }
    };

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };

    const BackFunc = () => {
        navigate.push("/index");
    };

    return (
        <>
            <div className="page-content-wrapper">
                {loading ? (
                    <div className="page-content d-flex justify-content-center align-items-center">
                        <div className="my-wrapper">
                            <div class="spinner center">
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                            </div>
                        </div>

                    </div>
                ) : (<></>)
                }
                <div className="page-content">

                    {loading ? (
                        <>
                            <div className="page-bar" style={{ display: "none" }}>
                                <div className="page-title-breadcrumb">
                                    <div className=" pull-left">
                                        <div className="page-title my-0">List of Questions</div>
                                    </div>
                                </div>

                                <div className="page-title-breadcrumb">
                                    <div className=" pull-right">
                                        <button
                                            type="submit"
                                            className="btn d-inline-block"
                                            style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                            onClick={BackFunc}
                                        >
                                            {" "}
                                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ display: "none" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group custom-form-padding">
                                        <div className="row gx-1">
                                            <div className="col-lg-12">
                                                <div className="form-group row gx-1">
                                                    <div className="col">
                                                        <label className="col-12 control-label">Question</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="Chint"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Question"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            User Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="UrNm"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter User Name"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            Case Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="CaseNm"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Case Name"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">Case ID</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="PID"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Case ID"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">Response</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="CaseResp"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Response"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row gx-1">
                                                    <div className="col-md-3 custom-datepicker">
                                                        <label className="col-12 control-label">
                                                            {" "}
                                                            From Date
                                                        </label>
                                                        <DatePicker
                                                            selected={fromdate}
                                                            onChange={handlefromdate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="fromdate"
                                                        />
                                                    </div>
                                                    <div className="col-md-3 custom-datepicker">
                                                        <label className="col-12  control-label">To date</label>
                                                        <DatePicker
                                                            selected={todate}
                                                            onChange={handletodate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="todate"
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-3 col-md-9">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2"
                                                    style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                                >
                                                    Search
                                                </button>

                                                {/* <button style={{ backgroundColor: '#76B947'}}> */}
                                                {/* <button type="button" onClick={handleDownloadCsv} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"> */}
                                                <CSVLink
                                                    data={csvData}
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                                                    filename={"ChatGptFile.csv"}
                                                    target="_blank"
                                                    style={{ color: "black" }}
                                                >
                                                    Export
                                                </CSVLink>

                                                {/* </button> */}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div></>
                    ) : (
                        <>
                            <div className="page-bar">
                                <div className="page-title-breadcrumb">
                                    <div className=" pull-left">
                                        <div className="page-title my-0">List of Questions</div>
                                    </div>
                                </div>

                                <div className="page-title-breadcrumb">
                                    <div className=" pull-right">
                                        <button
                                            type="submit"
                                            className="btn d-inline-block"
                                            style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                            onClick={BackFunc}
                                        >
                                            {" "}
                                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group custom-form-padding">
                                        <div className="row gx-1">
                                            <div className="col-lg-12">
                                                <div className="form-group row gx-1">
                                                    {/* <div className="col-md-3">
                        <label className="col-12 col-md-4 control-label">
                          Source
                        </label>
                        <select
                          className="form-control  select2"
                          value={EType}
                          onChange={handleChangeType}
                        >
                          <option value="">All questions</option>
                          <option value="GPT">GPT</option>
                          <option value="Global">Global</option>
                          <option value="Custom">Custom</option>
                        </select>
                      </div> */}

                                                    <div className="col">
                                                        <label className="col-12 control-label">Question</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="Chint"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Question"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            User Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="UrNm"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter User Name"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            Case Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="CaseNm"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Case Name"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">Case ID</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="PID"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Case ID"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">Response</label>
                                                        <input
                                                            type="text"
                                                            // value={formData.pId}
                                                            onChange={handleChange}
                                                            name="CaseResp"
                                                            className="form-control"
                                                            id="simpleFormEmail"
                                                            placeholder="Enter Response"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row gx-1">
                                                    <div className="col-md-3 custom-datepicker">
                                                        <label className="col-12 control-label">
                                                            {" "}
                                                            From Date
                                                        </label>
                                                        <DatePicker
                                                            selected={fromdate}
                                                            onChange={handlefromdate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="fromdate"
                                                        />
                                                    </div>
                                                    <div className="col-md-3 custom-datepicker">
                                                        <label className="col-12  control-label">To date</label>
                                                        <DatePicker
                                                            selected={todate}
                                                            onChange={handletodate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="todate"
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-3 col-md-9">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2"
                                                    style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                                >
                                                    Search
                                                </button>

                                                {/* <button style={{ backgroundColor: '#76B947'}}> */}
                                                {/* <button type="button" onClick={handleDownloadCsv} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"> */}
                                                <CSVLink
                                                    data={csvData}
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                                                    filename={"ChatGptFile.csv"}
                                                    target="_blank"
                                                    style={{ color: "black" }}
                                                >
                                                    Export
                                                </CSVLink>

                                                {/* </button> */}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-head">
                                                    <header>Question List</header>
                                                    <div className="tools">
                                                        {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                                <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a>
                                                <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                                                    </div>
                                                </div>
                                                <div className="card-body ">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped custom-table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Case ID</th>
                                                                    <th>User Name</th>
                                                                    <th>Case Name</th>
                                                                    <th> Question</th>
                                                                    {/* <th> Intents</th> */}
                                                                    <th style={{ width: "300px" }}>Response</th>
                                                                    <th style={{ width: "300px" }}>Expression</th>
                                                                    {/* <th>Source</th> */}
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Record > 10
                                                                    ? paginatedPosts &&
                                                                    paginatedPosts.length > 0 &&
                                                                    paginatedPosts.map((item) => (
                                                                        <tr>
                                                                            <td className="text-left">{item.p_Id}</td>
                                                                            <td className="text-left">
                                                                                {item.userName}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {item.caseName}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {item.question}
                                                                            </td>
                                                                            {/* <td className="text-left">{item.intent}</td> */}
                                                                            <td className="text-left">
                                                                                {JSON.parse(item.responces).response}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {JSON.parse(item.responces).emotion}
                                                                            </td>
                                                                            {/* <td className="text-left">{item.source}</td> */}
                                                                            <td className="text-left td-date">
                                                                                {item.timestamp}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    : QuesList2 &&
                                                                    QuesList2.length > 0 &&
                                                                    QuesList2.map((item) => (
                                                                        <tr>
                                                                            <td className="text-left">{item.p_Id}</td>
                                                                            <td className="text-left">
                                                                                {item.userName}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {item.caseName}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {item.question}
                                                                            </td>
                                                                            {/* <td className="text-left">{item.intent}</td> */}
                                                                            <td className="text-left">
                                                                                {JSON.parse(item.responces).response}
                                                                            </td>
                                                                            <td className="text-left">
                                                                                {JSON.parse(item.responces).emotion}
                                                                            </td>
                                                                            {/* <td className="text-left">{item.source}</td> */}
                                                                            <td className="text-left td-date">
                                                                                {item.timestamp}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {Record > 10 ? (
                                                        <ReactPaginate
                                                            previousLabel={"Prev"}
                                                            nextLabel={"Next"}
                                                            breakLabel={"..."}
                                                            pageCount={pageCount}
                                                            marginPagesDisplayed={2}
                                                            pageRangeDisplayed={3}
                                                            onPageChange={handlePageClick}
                                                            containerClassName={
                                                                "pagination justify-content-center"
                                                            }
                                                            pageClassName={"page-item"}
                                                            pageLinkClassName={"page-link"}
                                                            activeClassName={"active"}
                                                            previousClassName={"page-item"}
                                                            nextClassName={"page-item"}
                                                            previousLinkClassName={"page-link"}
                                                            nextLinkClassName={"page-link"}
                                                        />
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default ChatGptList;
